import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthAPI } from '../../api/client';
import {
  AuthLayout, ErrorText, useAuthConfig, passwordMeetsPolicy, PasswordHints,
  input, label, button, linkRow, linkStyle,
} from './authShared';

/** Handles Cognito's NEW_PASSWORD_REQUIRED challenge — the first login of an
 *  admin-created evaluator/admin, who must replace their temporary password.
 *  Reached from /login after a `new_password_required` result; the in-flight
 *  challenge lives in a short-lived httpOnly cookie set by the backend. */
export default function NewPasswordChallenge() {
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!passwordMeetsPolicy(password, cfg?.passwordPolicy)) {
      setError('Please choose a password that meets the requirements above.'); return;
    }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    const r = await AuthAPI.setNewPassword(password);
    if (r.ok && r.status === 'ok') { window.location.assign('/'); return; }
    if (r.ok && r.status === 'mfa_required') { nav('/mfa'); return; }
    setBusy(false);
    setError(r.message || 'Couldn’t set your password. Please sign in again to retry.');
  };

  return (
    <AuthLayout title="Set your password" subtitle="Your account needs a new password to finish signing in.">
      <form onSubmit={submit}>
        <label style={label}>New password
          <input style={input} type="password" autoComplete="new-password" value={password}
                 onChange={e => setPassword(e.target.value)} autoFocus />
        </label>
        <PasswordHints policy={cfg?.passwordPolicy} />
        <label style={label}>Confirm new password
          <input style={input} type="password" autoComplete="new-password" value={confirm}
                 onChange={e => setConfirm(e.target.value)} />
        </label>
        <ErrorText>{error}</ErrorText>
        <button type="submit" style={button} disabled={busy}>{busy ? 'Saving…' : 'Set password & continue'}</button>
      </form>
      <p style={linkRow}><Link to="/login" style={linkStyle}>Back to sign in</Link></p>
    </AuthLayout>
  );
}
